import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import SettingReducer from './SettingReducer';
import WebchatSettingsReducer from './WebchatSettingsReducer';
import WebchatEmailTemplateReducer from './WebchatEmailTemplateReducer';
import WebchatBrandingElementsReducer from './WebchatBrandingElementsReducer';
import SystemConfigurationReducer from './SystemConfigurationReducer';


const appReducer = combineReducers({
  SystemConfigurationReducer,
  loginReducer,
  SettingReducer,
  WebchatBrandingElementsReducer,
  WebchatSettingsReducer,
  WebchatEmailTemplateReducer
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = { };
  }
  return appReducer(state, action);
};

export default rootReducer;
